import React, { useState } from 'react';

import RetailerOverviewDropdown from './retailer-overview-base-dropdown';
import InfoModal from './info-modal';

import './styles/payment-models-dropdown.scss';

const PaymentModelsDropdown = ({ paymentModels, setPaymentModels }) => {
  const [displayModal, setDisplayModal] = useState(false);

  const paymentModelModal = displayModal ? (
    <InfoModal setDisplayModal={setDisplayModal} modalType="payment-models" />
  ) : null;

  return (
    <div className="payment-models-dropdown">
      <RetailerOverviewDropdown
        type="payment-models"
        items={paymentModels}
        updateOptions={setPaymentModels}
        miscDropdownContent={
          <div className="modal-btn" onClick={() => setDisplayModal(true)}>
            Learn more about <br /> payment models
          </div>
        }
        gaEvent={{ category: 'Retailer Overview', label: 'Payment Models Dropdown' }}
      />
      {paymentModelModal}
    </div>
  );
};

export default PaymentModelsDropdown;
